module.exports = __webpack_public_path__ + "static/media/italy.761d1a52.jpg";